import { ReactNode, createContext, useContext } from 'react';
import { defaultCopy, wardrobeDefaultCopy } from '../copy';
import { CopyFragment } from '../hooks/getCopy';
import { WardrobeCopyFragment } from '../hooks/getWardrobeCopy';

interface CopyContext {
  copy: CopyFragment;
}

interface WardrobeCopyContext {
  copy: WardrobeCopyFragment;
}

interface CopyProviderProps {
  children: ReactNode;
  copy: CopyFragment;
}

interface WardrobeCopyProviderProps {
  children: ReactNode;
  copy: WardrobeCopyFragment;
}

const CopyContext = createContext<CopyContext>({
  copy: defaultCopy,
});

const WardrobeCopyContext = createContext<WardrobeCopyContext>({
  copy: wardrobeDefaultCopy,
});

export const useCopy = () => useContext(CopyContext);
export const useWardrobeCopy = () => useContext(WardrobeCopyContext);

/**
 * Copy Provider for Search
 */
export const CopyProvider = ({ children, copy }: CopyProviderProps) => (
  <CopyContext.Provider value={{ copy }}>{children}</CopyContext.Provider>
);

/**
 * Copy Provider for Wardrobe pages: bought-items & saved-items
 */
export const WardrobeCopyProvider = ({
  children,
  copy,
}: WardrobeCopyProviderProps) => (
  <WardrobeCopyContext.Provider value={{ copy }}>
    {children}
  </WardrobeCopyContext.Provider>
);
